import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { isVisible: boolean; boxCount: number; scale: number }>({
  root: {
    display: (props: any) => (props.isVisible ? 'block' : 'none'),
    opacity: 0,
    position: 'absolute',
    zIndex: '-1',
  },
  PDF: {
    background: '#F4F5F8',
    width: (props: any) => 2480 / props.scale,
    height: (props: any) => 3508 / props.scale,
    padding: (props: any) => `${93 / props.scale}px ${69 / props.scale}px`,
  },
  PDFContainer: {
    background: '#FFFFFF',
    width: '100%',
    height: '100%',
    borderRadius: (props: any) => 82 / props.scale,
    textAlign: 'center',
    padding: (props: any) => 229 / props.scale,
  },
  PDFContainerTitle: {
    color: '#080808',
    fontSize: (props: any) => 144 / props.scale,
    fontFeatureSettings: "'kern' off",
    fontWeight: 'Bold',
  },
  PDFContainerDescription: {
    marginTop: (props: any) => 24 / props.scale,
    fontSize: (props: any) => 86 / props.scale,
    color: '#121212',
    fontFeatureSettings: "'kern' off",
    fontWeight: 500,
  },
  PDFContainerColors: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-around',
    marginTop: (props: any) => 246 / props.scale,
  },
  PDFContainerColorsItem: {
    height: (props: any) => 534 / props.scale,
    width: (props: any) => (props.boxCount === 4 ? 386 / props.scale : 534 / props.scale),
  },
  PDFContainerColorsItemColor: {
    width: '100%',
    height: '100%',
    borderRadius: (props: any) => 42 / props.scale,
    background: 'red',
  },
  PDFContainerColorsItemColorHexCode: {
    fontSize: (props: any) => 50 / props.scale,
  },
  PDFContainerColorsItemSpace: {
    height: (props: any) => 50 / props.scale,
  },
  PDFContainerColorsItemInfo: {
    marginTop: (props: any) => 60 / props.scale,
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  PDFContainerColorsItemInfoCode: {
    minHeight: (props: any) => 50 / props.scale,
    minWidth: (props: any) => 234 / props.scale,
    color: '#080808',
    fontSize: (props: any) => 40 / props.scale,
    fontFeatureSettings: "'kern' off",
  },
  PDFContainerColorsItemInfoType: {
    color: '#949494',
    fontSize: (props: any) => 40 / props.scale,
    fontFeatureSettings: "'kern' off",
  },
  PDFContainerURL: {
    minHeight: (props: any) => 48 / props.scale,
    marginTop: (props: any) => 1700 / props.scale,
    fontSize: (props: any) => 36 / props.scale,
    marginBottom: (props: any) => 58 / props.scale,
  },
  PDFContainerFooter: {
    margin: 'auto',
    width: (props: any) => 406 / props.scale,
    display: 'flex',
    justifyContent: 'space-between',
  },
  PDFContainerFooterLogo: {
    '&>svg': {
      width: (props: any) => 60 / props.scale,
      height: (props: any) => 60 / props.scale,
    },
  },
  PDFContainerFooterMain: {
    color: '#C209C1',
    fontSize: (props: any) => 54 / props.scale,
  },
  PDFContainerFooterText: {
    color: '#000000',
    fontSize: (props: any) => 54 / props.scale,
  },
});

export default useStyles;
